import React from "react"
import styled from "styled-components"
import CommonInput from "./input"
import { APP_ID } from "../../helpers/constants"
import { Show } from "@styled-icons/boxicons-solid/Show"
import { Hide } from "@styled-icons/boxicons-solid/Hide"

const ShowIcon = styled(Show)`
    color: #3F5F8B;
    width: 2.6rem;
`

const HideIcon = styled(Hide)`
    color: #3F5F8B;
    width: 2.6rem;
`

const TogglePasswordContainer = styled.div`
    width: 100%;
    align-items: flex-end;
    display: flex;
`
const TogglePasswordCol = styled.div`
    width: 100%;
    display: inline-block;
`
const ToggleControllerCol = styled.div`
    display: inline-block;
    font-weight: 700;
    /* color: rgba(10, 10, 220, 0.5);  */
    color: ${props => props.theme[APP_ID].primary};
    padding: 0 1.2rem;
    font-size: 1rem;
    text-align: center;
    cursor: pointer;
`

const TogglePassword = props => {
    const { onClick, formFieldsDisabled, inputType, error, onChange, toggleLabel, label, inputRef, onKeyPress, onKeyDown } = props

    return <TogglePasswordContainer>
        <TogglePasswordCol>
            <CommonInput
                disabled={formFieldsDisabled}
                label={label}
                placeholder="8+ alphanumeric characters"
                type={inputType}
                error={error}
                onChange={onChange}
                inputRef={inputRef}
                onKeyPress={onKeyPress}
                onKeyDown={onKeyDown}
                rightComponent={
                    <ToggleControllerCol onClick={onClick}>
                        {toggleLabel === "SHOW" ? <ShowIcon /> : <HideIcon />}
                    </ToggleControllerCol>
                }
            />
        </TogglePasswordCol>

    </TogglePasswordContainer>
}

export default TogglePassword